import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Accessibility statement</h1>
      <p>Preston MyScan is provided to you by Preston City Council and has been developed by Looking Local. It is designed to be used by as many people as possible. The text should be clear and simple to understand. You should be able to:</p>
      <ul>
        <li>zoom in up to 300% without the text spilling off the screen</li>
        <li>navigate most of the web app using just a keyboard</li>
        <li>navigate most of the web app using speech recognition software</li>
        <li>listen to most of the web app using a screen reader (including the most recent versions of JAWS, NVDA and VoiceOver)</li>
      </ul>
      <br />
      <p><a href="https://mcmw.abilitynet.org.uk">AbilityNet</a> has advice on making your device easier to use if you have a disability.</p>
      <p><strong>How accessible this web app is</strong><br />
        Parts of this web app are not fully accessible. For example:
        <ul>
          <li>some form elements are not correctly identified</li>
        </ul>
      </p>
      <br />
      <p><strong>How to request content in an accessible format</strong><br />
        If you need information on this web app in a different format, <a href="mailto:webmanager@preston.gov.uk">contact us</a> and tell us:
        <ul>
          <li>the web address (URL) of the content</li>
          <li>your name and email address</li>
          <li>the format you need. For example: audio CD, braille, BSL or large print, accessible PDF</li>
        </ul>
      </p>
      <br />
      <p><strong>Reporting accessibility problems with this app</strong><br />
        If you find any problems that are not listed on this page, or you think we’re not meeting the accessibility requirements, <a href="mailto:webmanager@preston.gov.uk">contact us</a> and tell us:
        <ul>
          <li>the web address (URL) and location of any non-compliant content</li>
          <li>your name and email address</li>
        </ul>
      </p>
      <br />
      <p><strong>Enforcement procedure</strong><br />
        <p>If you are not happy with our response, please visit <a href="https://www.preston.gov.uk/article/1216/Complaints">Preston City Council complaints procedure</a></p>
        The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018 (the ‘accessibility regulations’).
      </p>
      <br />
      <p><strong>Technical information about this web app's accessibility</strong><br />
        <p>Preston City Council and Looking Local are committed to making this web app accessible, in accordance with the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018.</p>
        This web app is partially compliant with the <a href="https://www.w3.org/TR/WCAG21/">Web Content Accessibility Guidelines version 2.1</a> AA standard.
      </p>
      <br />
      <p><strong>Non-accessible content</strong><br />
        The content that is not accessible is outlined below
      </p>
      <p>Some form elements do not have a label, which affects how they work with assistive technology. This fails WCAG 2.1A success criterion 1.3.1, 3.3.2 (Name, Role, Value).</p><br />
      <p><strong>Disproportionate burden</strong><br />
        Not applicable.
      </p>
      <br />
      <p><strong>Content that’s not within the scope of the accessibility regulations</strong><br />
        Not applicable.
      </p>
      <br />
      <p><strong>How we tested this web app</strong><br />
        <p>This web app was last tested for compliance with the Web Content Accessibility Guidelines (version 2.1) level AA on 5 October 2022. The test was carried out internally by Looking Local.</p>
        <p>Looking Local used an automated testing tool <a href="https://accessibilityinsights.io/docs/en/web/overview#what-s-accessibility-insights-for-web">Accessibility Insights for Web</a> to test a subset of web pages, ensuring all the main areas of the web app were included in the sample. The results were recorded and accessibility issues discovered have been added to the accessibility roadmap.</p>
        Looking Local tested the MyScan web app, available at <a href="https://preston.scanstation.lookinglocal.gov.uk/#/home">https://preston.scanstation.lookinglocal.gov.uk/#/home</a>
      </p>
      <br />
      <p><strong>What we’re doing to improve accessibility</strong><br />
        <p>We are urgently fixing content which fails to meet the Web Content Accessibility Guidelines version 2.1 AA standard. We will update this page when issues are fixed.</p>
        This statement was prepared on 22 May 2020. It was last updated on 5 October 2022.
      </p>

    </React.Fragment>
  );
}
